import React, { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { Star, Quote } from "lucide-react";
import { motion } from "framer-motion";

export const Testimonials = () => {
  const { t, lang } = useApp();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/reviews/featured").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16" data-testid="testimonials">
      <div className="text-center mb-10">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-800 mb-3">{t.reviews.homeTitle}</h2>
        <p className="text-slate-500">{t.reviews.homeSub}</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((rv, i) => (
          <motion.div key={rv.id} initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.07 }}
            data-testid={`testimonial-${rv.id}`} className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6 relative">
            <Quote size={28} className="absolute top-4 end-4 text-gold/30" />
            <div className="flex items-center gap-0.5 mb-3">
              {[1, 2, 3, 4, 5].map((n) => <Star key={n} size={14} className={n <= rv.rating ? "fill-gold text-gold" : "text-slate-200"} />)}
            </div>
            <p className="text-sm text-slate-600 leading-relaxed mb-4 line-clamp-4">{rv.comment}</p>
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-full bg-tigris/10 text-tigris font-bold flex items-center justify-center text-sm">{(rv.user_name || "?").charAt(0)}</span>
              <div>
                <div className="font-bold text-slate-800 text-sm">{rv.user_name}</div>
                <div className="text-[11px] text-slate-400">{new Date(rv.created_at).toLocaleDateString(lang === "ar" ? "ar-IQ" : "en-US")}</div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
